module.exports = "../study/imgs/maps/Tokyo/S8/Climate/Precipitation/Tokyo_Precipitation_GFDL_RCP85_Now.png";